import React, { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';

import getTheme from 'utils/getTheme';
import { useConfig } from './ConfigProvider';

interface Props {
  children: React.ReactNode;
}
const ThemeProviderWrapper = ({ children }: Props) => {
  const config = useConfig();
  const theme = getTheme();
  const [insets, setInsets] = useState({
    safeAreaInsetTop: 0,
    safeAreaInsetBottom: 0,
  });

  useEffect(() => {
    const root = document.documentElement;
    const safeAreaInsetTop = parseInt(getComputedStyle(root).getPropertyValue('--sat') || '0', 10);
    const safeAreaInsetBottom = parseInt(
      getComputedStyle(root).getPropertyValue('--sab') || '0',
      10,
    );

    setInsets({ safeAreaInsetTop, safeAreaInsetBottom });
  }, []);

  return (
    <ThemeProvider
      theme={{
        ...theme,
        ...config.THEME,
        safeAreaInsetBottom: insets.safeAreaInsetBottom,
        safeAreaInsetTop: insets.safeAreaInsetTop,
      }}>
      {children}
    </ThemeProvider>
  );
};

export default ThemeProviderWrapper;
